import { render } from "./Userlist.vue?vue&type=template&id=ca02fd44"
import script from "./Userlist.vue?vue&type=script&lang=js"
export * from "./Userlist.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__